import { render, staticRenderFns } from "./SideNavMinhasSimulacoes.vue?vue&type=template&id=9f2ecae8&"
import script from "./SideNavMinhasSimulacoes.vue?vue&type=script&lang=js&"
export * from "./SideNavMinhasSimulacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports